const Accordion = (el) => {
  const $accordion = $(el);
  const $panel = $accordion.find('.js-accordion-panel');
  const $button = $accordion.find('.accordion__button');
  const $content = $accordion.find('.js-accordion-content');

  const toggleAccordion = () => {
    const isExpanded = $button.attr('aria-expanded') === 'true';
    $button.attr('aria-expanded', String(!isExpanded));

    if (isExpanded) {
      $content.slideUp(200).attr('hidden', true).attr("aria-hidden", true);
      $panel.removeClass('active');
      $button.attr("aria-label", "Expandera")
    } else {
      $content.slideDown(200).removeAttr('hidden').attr("aria-hidden", false);
      $panel.addClass('active');
      $button.attr("aria-label", "Minimera")
    }
  };

  $panel.on('click', toggleAccordion);
}

export default Accordion;
